const messages = {
  _default: field => `ข้อมูล ${field} ไม่ถูกต้อง`,
  after: (field, [target]) => `ข้อมูล ${field} ต้องเป็นวันที่หลังจาก ${target}.`,
  alpha_dash: field => `ข้อมูล ${field} ต้องเป็นตัวอักษรภาษาอังกฤษ ตัวเลข และ _ เท่านั้น`,
  alpha_num: field => `ข้อมูล ${field} ต้องเป็นตัวอักษรภาษาอังกฤษ ตัวเลข เท่านั้น`,
  alpha_spaces: field => `ข้อมูล ${field} ต้องเป็นตัวอักษรภาษาอังกฤษ ช่องว่าง เท่านั้น`,
  alpha: field => `ข้อมูล ${field} ต้องเป็นตัวอักษรภาษาอังกฤษเท่านั้น`,
  before: (field, [target]) => `ข้อมูล ${field} ต้องเป็นวันที่ก่อนหน้า ${target}.`,
  between: (field, [min, max]) => `ข้อมูล ${field} ต้องอยู่ในช่วงระหว่าง ${min} - ${max}.`,
  confirmed: field => `The ${field} confirmation does not match.`,
  credit_card: field => `ข้อมูล ${field} ไม่ถูกต้อง`,
  date_between: (field, [min, max]) => `ข้อมูล ${field} ต้องเป็นวันที่ระหว่าง ${min} - ${max}.`,
  date_format: (field, [format]) => `ข้อมูล ${field} ต้องเป็น ${format}.`,
  decimal: (field, [decimals] = ['*']) => `The ${field} must be numeric and may contain ${decimals === '*' ? '' : decimals} decimal points.`,
  digits: (field, [length]) => `The ${field} must be numeric and exactly contain ${length} digits.`,
  dimensions: (field, [width, height]) => `The ${field} must be ${width} pixels by ${height} pixels.`,
  email: field => `The ${field} must be a valid email.`,
  ext: field => `The ${field} must be a valid file.`,
  image: field => `The ${field} must be an image.`,
  in: field => `The ${field} must be a valid value.`,
  ip: field => `The ${field} must be a valid ip address.`,
  max: (field, [length]) => `ข้อมูล ${field} ต้องมีความยาวไม่เกิน ${length} ตัวอักษร`,
  max_value: (field, [max]) => `ข้อมูล ${field} ต้องมีจำนวนไม่เกิน ${max} หรือน้อยกว่า`,
  mimes: field => `The ${field} must have a valid file type.`,
  min: (field, [length]) => `ข้อมูล ${field} ต้องมีความยาวไม่น้อยกว่า ${length} ตัวอักษร`,
  min_value: (field, [min]) => `ข้อมูล ${field} ต้องมีจำนวนอย่างน้อย ${min}`,
  not_in: field => `The ${field} must be a valid value.`,
  numeric: field => `ข้อมูล ${field} ต้องเป็นตัวเลข`,
  regex: field => `The ${field} format is invalid.`,
  required: field => `ข้อมูล ${field} จำเป็นต้องกรอก`,
  size: (field, [size]) => `The ${field} must be less than ${size} KB.`,
  url: field => `The ${field} is not a valid URL.`,
  namespace: field => `${field} ต้องประกอบด้วย 3-32 ตัวอักษร และต้องเป็นตัวภาษาอังกฤษพิมพ์เล็ก ตัวเลข และ _ เท่านั้น`,
  custom_price_between: (field, [min, max], value) => {
    if (Number(value) < Number(min)) {
      return `กรุณาเติมเครดิตอย่าง้นอย ${Number(min).toLocaleString()} บาท`;
    } else if (Number(value) > Number(max)) {
      return `กรุณาติดต่อทีมงาน ByteArk หากคุณต้องการเติมเครดิตมากกว่า ${Number(max).toLocaleString()} บาท`;
    }
    return `${field} ต้องออยู่ระหว่าง ${Number(min).toLocaleString()} - ${Number(max).toLocaleString()}.`;
  },
};

const locale = {
  name: 'th',
  messages,
  attributes: {
    email: 'อีเมล',
    password: 'รหัสผ่าน',
    new_password: 'รหัสผ่านใหม่',
    confirm_new_password: 'ยืนยันรหัสผ่านใหม่',
    team: 'ชื่อทีม',
    displayname: 'ชื่อที่ใช้แสดงผล',
    role: 'สิทธิ์ของสมาชิก',
    first_name: 'ชื่อ',
    last_name: 'นามสกุล',
    address1: 'ที่อยู่',
    city: 'เขต / อำเภอ',
    state: 'แขวง / จังหวัด',
    zipcode: 'รหัสไปรษณีย์',
    country: 'ประเทศ',
    contact_phone: 'เบอร์โทรศัพท์ที่ใช้ติดต่อ',
    contact_email: 'อีเมลที่ใช้ติดต่อ',
  },
};

export default locale;



// WEBPACK FOOTER //
// ./src/lang/validator/th.js